import { createContext } from 'react'
const broadcastContext = createContext()
export default broadcastContext